import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cx-dropdown-item',
  templateUrl: './cx-dropdown-item.component.html',
  styleUrls: ['./cx-dropdown-item.component.scss']
})
export class CxDropdownItemComponent implements OnInit {

  @Input()
  values: any;

  @Output()
  select: EventEmitter<any>;

  constructor() {
    this.select = new EventEmitter();
  }

  selectItem(value): void {
    this.select.emit(value);
  }

  ngOnInit(): void {
  }

}

